import { default as _91_46_46_46404_93dMgKFsN6Q6Meta } from "/usr/src/packages/error-handling/pages/[...404].vue?macro=true";
import { default as about4C1BTiVyMhMeta } from "/usr/src/apps/base/src/pages/about.vue?macro=true";
import { default as accessibility08XNiHGQ0oMeta } from "/usr/src/apps/base/src/pages/accessibility.vue?macro=true";
import { default as contactwZAZ1OhQATMeta } from "/usr/src/apps/base/src/pages/contact.vue?macro=true";
import { default as datasecurityk9e8JnurInMeta } from "/usr/src/apps/base/src/pages/datasecurity.vue?macro=true";
import { default as disclosureIQD52U35CiMeta } from "/usr/src/apps/base/src/pages/disclosure.vue?macro=true";
import { default as etf8PPzlqWJjKMeta } from "/usr/src/apps/finq-ai/src/pages/etf.vue?macro=true";
import { default as forgotpassword3Ou1x7Xjk4Meta } from "/usr/src/apps/base/src/pages/forgotpassword.vue?macro=true";
import { default as indexIuH6o32MW7Meta } from "/usr/src/apps/finq-ai/src/pages/index.vue?macro=true";
import { default as loginYIEPQC6mhGMeta } from "/usr/src/apps/base/src/pages/login.vue?macro=true";
import { default as passwordresetawaitFAii2hbFCfMeta } from "/usr/src/apps/base/src/pages/passwordresetawait.vue?macro=true";
import { default as privacyW7FWgOcv9fMeta } from "/usr/src/apps/base/src/pages/privacy.vue?macro=true";
import { default as infoFL8Bz5DpZJMeta } from "/usr/src/apps/base/src/pages/profile/info.vue?macro=true";
import { default as profilezv8G5W5pJQMeta } from "/usr/src/apps/base/src/pages/profile.vue?macro=true";
import { default as signupD0zLV4v9noMeta } from "/usr/src/apps/base/src/pages/signup.vue?macro=true";
import { default as callback0Nh93rez4dMeta } from "/usr/src/apps/base/src/pages/subscribe/callback.vue?macro=true";
import { default as termsofusel5AzRHu0H7Meta } from "/usr/src/apps/base/src/pages/termsofuse.vue?macro=true";
import { default as trademark_45copyright_45intellectual_45propertyMbnBQ4r9vbMeta } from "/usr/src/apps/base/src/pages/trademark-copyright-intellectual-property.vue?macro=true";
import { default as verify2fhYk5060fMeta } from "/usr/src/apps/base/src/pages/verify.vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    meta: _91_46_46_46404_93dMgKFsN6Q6Meta || {},
    component: () => import("/usr/src/packages/error-handling/pages/[...404].vue")
  },
  {
    name: "about",
    path: "/about",
    meta: about4C1BTiVyMhMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/about.vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    component: () => import("/usr/src/apps/base/src/pages/accessibility.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactwZAZ1OhQATMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/contact.vue")
  },
  {
    name: "datasecurity",
    path: "/datasecurity",
    meta: datasecurityk9e8JnurInMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/datasecurity.vue")
  },
  {
    name: "disclosure",
    path: "/disclosure",
    component: () => import("/usr/src/apps/base/src/pages/disclosure.vue")
  },
  {
    name: "etf",
    path: "/etf",
    meta: etf8PPzlqWJjKMeta || {},
    component: () => import("/usr/src/apps/finq-ai/src/pages/etf.vue")
  },
  {
    name: "forgotpassword",
    path: "/forgotpassword",
    meta: forgotpassword3Ou1x7Xjk4Meta || {},
    component: () => import("/usr/src/apps/base/src/pages/forgotpassword.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexIuH6o32MW7Meta || {},
    component: () => import("/usr/src/apps/finq-ai/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginYIEPQC6mhGMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/login.vue")
  },
  {
    name: "passwordresetawait",
    path: "/passwordresetawait",
    meta: passwordresetawaitFAii2hbFCfMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/passwordresetawait.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyW7FWgOcv9fMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/privacy.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profilezv8G5W5pJQMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/profile.vue"),
    children: [
  {
    name: "profile-info",
    path: "info",
    meta: infoFL8Bz5DpZJMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/profile/info.vue")
  }
]
  },
  {
    name: "signup",
    path: "/signup",
    meta: signupD0zLV4v9noMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/signup.vue")
  },
  {
    name: "subscribe-callback",
    path: "/subscribe/callback",
    meta: callback0Nh93rez4dMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/subscribe/callback.vue")
  },
  {
    name: "termsofuse",
    path: "/termsofuse",
    meta: termsofusel5AzRHu0H7Meta || {},
    component: () => import("/usr/src/apps/base/src/pages/termsofuse.vue")
  },
  {
    name: "trademark-copyright-intellectual-property",
    path: "/trademark-copyright-intellectual-property",
    meta: trademark_45copyright_45intellectual_45propertyMbnBQ4r9vbMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/trademark-copyright-intellectual-property.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: verify2fhYk5060fMeta || {},
    component: () => import("/usr/src/apps/base/src/pages/verify.vue")
  }
]